import React from 'react';
import { KeyDownEventLink } from '../../utils/eventKey';
/**
 * Pagination Component
 */

 class PaginationComp extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            currentPage: 1
        };
        this.getPage = this.getPage.bind(this);
    }

    getPage(page, pagerLength,  e){
        let currentPage = this.state.currentPage;
        let {number, label} = page;
        if(currentPage == number || (label == '»' && currentPage == pagerLength) || (label == '«' && currentPage == 1)){
            return;
        }
        if(this.props.setPageEventHandler){
            console.log('getPage 1', number);
            this.props.setPageEventHandler(number);
            this.setState({
                currentPage: number
            });
        }
    }

    renderPager(){
        let pager = this.getPager();
        let currentPage = this.state.currentPage;
        let pagerLength = pager.length - 2;
        if(pagerLength){
            return pager.map( (page) =>{
                let ariaDisabled = null;
                let ariaLabel = null;
                let ariaCurrent = null;
                let activePage = (currentPage == page.label || (page.label == '»' && currentPage != pagerLength) || (page.label == '«' && currentPage != 1) )
                ariaLabel =  page.label == '»' ? 'Last Page' : page.label  == '«' ? 'First Page' : null;
                if(page.label == '»' || page.label == '«'){
                    ariaDisabled = activePage ? false : true;
                }
                else{
                    ariaCurrent = activePage ? true : false;
                }
                let classNames = (activePage ? "active" : "") + " " + page.className
                return  <li   className={"pagination-comp-li " + (page.className ? "pagination-comp-li-" + page.className : "")}>
                <span aria-current={ariaCurrent} aria-disabled={ariaDisabled}  aria-label={ariaLabel} onClick={ (e) =>{this.getPage(page, pagerLength, e);this.setfocus(e)}} onKeyDown={(e)=>{KeyDownEventLink(e,()=>{
                    this._handleKeyDown(page, pagerLength, page.label, e)})}} role="link" tabIndex="0"  className={classNames}>{page.label}</span>
                </li>
            }
            );
        }
        else{
            return null;
        }
    }
    
    setfocus(e){
        setTimeout(()=>{
            document.getElementById("table-wrapper").focus();
        },1000)

    }
    _handleKeyDown(page, pagerLength,label, e) {
        
            this.getPage(page, pagerLength, e);

            if(label != '»' && label != '«'){
                    // console.log(document.getElementById("table-wrapper"))
                    this.setfocus();

            }
        
    }

    getPager(){
        let pager = [];
        let {totalItems, perPageItem, maxPageSize} = this.props;
        let totalPage = Math.ceil(totalItems / perPageItem);
        if(totalPage == 1 || totalPage == 0){
            return pager;
        }
        pager = Array.from(Array(totalPage).keys()).map(i => {
            let id = i + 1;
            let pagerObj = {
                number: id,
                label: id,
                className: ""
            };
            return pagerObj;
        });

        let total = pager.length;
        //add first label <<
        pager.splice(0, 0, {number: 1, label: "«", className: "first"});
        // add last label >>
        pager.splice(pager.length, 0, {number: total, label: "»", className: "last"});
        return pager;
    }

    render(){
        return (
            <div className="pagination-comp-wrapper">
                <nav aria-label='History pagination'>
                    <ul  >
                        {
                            this.renderPager()
                        }
                    </ul>
                </nav>
            </div>
        );
    }
 }


 PaginationComp.defaultProps = {
    totalItems: 0,
    maxPageSize: 10,
    perPageItem: 10,
    setPageEventHandler: null
 }

export default PaginationComp;